import { LEGAL_VERSION } from '@/lib/marketing/legal/version';

export const PENDING_LEGAL_ACCEPTANCE_KEY = 'hiromatch_pending_legal_acceptance_v1';

export interface PendingLegalAcceptance {
  termsVersion: string;
  onerousClausesVersion: string;
  professionalDeclaration: boolean;
}

export function stashPendingLegalAcceptance(): void {
  if (typeof window === 'undefined') return;
  const payload: PendingLegalAcceptance = {
    termsVersion: LEGAL_VERSION,
    onerousClausesVersion: LEGAL_VERSION,
    professionalDeclaration: true,
  };
  window.sessionStorage.setItem(PENDING_LEGAL_ACCEPTANCE_KEY, JSON.stringify(payload));
}

export function consumePendingLegalAcceptance(): PendingLegalAcceptance | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(PENDING_LEGAL_ACCEPTANCE_KEY);
    if (!raw) return null;
    window.sessionStorage.removeItem(PENDING_LEGAL_ACCEPTANCE_KEY);
    return JSON.parse(raw) as PendingLegalAcceptance;
  } catch {
    return null;
  }
}
